/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddStockItemDto as DigiworkMaitreDPosDtoStockItemAddStockItemDto } from '../../models/Digiwork/MaitreD/Pos/DTO/StockItem/add-stock-item-dto';
import { StockItemDto as DigiworkMaitreDPosDtoStockItemStockItemDto } from '../../models/Digiwork/MaitreD/Pos/DTO/StockItem/stock-item-dto';

export interface AddStockItem$Params {
      body?: DigiworkMaitreDPosDtoStockItemAddStockItemDto
}

export function addStockItem(http: HttpClient, rootUrl: string, params?: AddStockItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemDto>> {
  const rb = new RequestBuilder(rootUrl, addStockItem.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemDto>;
    })
  );
}

addStockItem.PATH = '/api/stock-items';
